module.exports = __webpack_public_path__ + "static/consulting-illustration-bc022579a1265641c7809b823b087840.svg";